module.exports = __webpack_public_path__ + "img/logo_nor1.3834df3d.png";